import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetAcknowledgedDocuments } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useAcknowledgedDocuments = (loanRequestId: string) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAcknowledgedDocuments,
        schema: schemaLoanRequestResolver_GetAcknowledgedDocuments,
        searchParams: { id: loanRequestId },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
